module.exports = __webpack_public_path__ + "static/media/123.748574b3.jpg";